import { createContext, ReactNode } from 'react';

export interface SideNavContextValue {
    content: ReactNode;
    setContent(node: ReactNode): void;
}

export const SideNavContext = createContext<SideNavContextValue>({
    content: <></>,
    setContent() {},
});
